<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div class="container-register-report">
  <div class="filters" *ngIf="data?.filterOptions">
    <div class="kpi">
      <div class="kpi-value">{{ totalAssets }}</div>
      <div class="kpi-label">TOTAL ASSETS</div>
    </div>

    <div class="filter-field filter-field--type">
      <mat-form-field appearance="fill">
        <mat-label>Type</mat-label>
        <mat-select multiple [(ngModel)]="selectedContainerTypes" (ngModelChange)="onFilterChange()">
          <mat-option *ngFor="let t of data.filterOptions.containerTypes" [value]="t">{{ t }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-field location-type-hidden">
      <mat-form-field appearance="fill">
        <mat-label>Location Type</mat-label>
        <mat-select multiple [(ngModel)]="selectedLocationTypes" (ngModelChange)="onFilterChange()">
          <mat-option *ngFor="let lt of data.filterOptions.locationTypes" [value]="lt">{{ lt }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-field">
      <mat-form-field appearance="fill">
        <mat-label>Container</mat-label>
        <mat-select
          multiple
          [(ngModel)]="selectedContainers"
          (ngModelChange)="onLocalFilterChange()"
          (openedChange)="onSelectOpenedChange($event, 'container')">
          <div class="select-search-option" (click)="$event.stopPropagation()">
            <input
              #containerSearchInput
              matInput
              placeholder="Search containers"
              [(ngModel)]="containerSearchTerm"
              [ngModelOptions]="{ standalone: true }"
              (click)="$event.stopPropagation()"
              (keydown)="onSearchKeydown($event)">
          </div>
          <mat-option *ngFor="let c of filteredContainerOptions" [value]="c">{{ c }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-field filter-field--location">
      <mat-form-field appearance="fill">
        <mat-label>Location</mat-label>
        <mat-select
          multiple
          [(ngModel)]="selectedLocations"
          (ngModelChange)="onLocalFilterChange()"
          (openedChange)="onSelectOpenedChange($event, 'location')">
          <div class="select-search-option" (click)="$event.stopPropagation()">
            <input
              #locationSearchInput
              matInput
              placeholder="Search locations"
              [(ngModel)]="locationSearchTerm"
              [ngModelOptions]="{ standalone: true }"
              (click)="$event.stopPropagation()"
              (keydown)="onSearchKeydown($event)">
          </div>
          <mat-option *ngFor="let l of filteredLocationOptions" [value]="l">{{ l }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-field">
      <mat-form-field appearance="fill">
        <mat-label>Status</mat-label>
        <mat-select multiple [(ngModel)]="selectedStatuses" (ngModelChange)="onLocalFilterChange()">
          <mat-option *ngFor="let s of statusOptions" [value]="s">{{ s }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-field filter-field--depot">
      <mat-form-field appearance="fill">
        <mat-label>Depot</mat-label>
        <mat-select multiple [(ngModel)]="selectedDepotIds" (ngModelChange)="onFilterChange()">
          <mat-option *ngFor="let d of data.filterOptions.depots" [value]="d.id">{{ d.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

  </div>

  <div class="charts-row">
    <mat-card class="bar-card">
      <mat-card-title>Balance By Container Type</mat-card-title>
      <div class="chart chart--bar">
        <canvas
          baseChart
          [type]="'bar'"
          [data]="barData"
          [options]="barOptions"
          [plugins]="barPlugins"
          (chartClick)="onBarChartClick($event)">
        </canvas>
      </div>
    </mat-card>

    <mat-card class="pie-card">
      <mat-card-title>Balance By Location Type</mat-card-title>
      <div class="pie-legend" *ngIf="pieLegendItems.length">
        <div class="pie-legend-item" *ngFor="let item of pieLegendItems">
          <span class="pie-legend-swatch" [style.background]="item.color"></span>
          <span class="pie-legend-text">{{ item.label }} ({{ item.percent }}%)</span>
        </div>
      </div>
      <div class="chart chart--pie">
        <canvas
          baseChart
          [type]="'pie'"
          [data]="pieData"
          [options]="pieOptions"
          [plugins]="piePlugins"
          (chartClick)="onPieChartClick($event)">
        </canvas>
      </div>
    </mat-card>
  </div>

  <div class="table-section">
    <div class="table-actions" *ngIf="allRows?.length">
      <button (click)="exportContainerRegister()" class="btn btn-white btn-sm">
        Export Data
        <span class="svg-icon svg-icon-xs ms-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Export data</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
        </span>
      </button>
    </div>

    <mat-card>
      <div class="table-wrap" *ngIf="filteredRows?.length">
        <table mat-table [dataSource]="filteredRows" class="mat-elevation-z1">
          <ng-container matColumnDef="containerId">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('containerId')">
              Id
              <span class="sort-indicator" [ngClass]="getSortDirection('containerId')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ r.containerId }}</td>
          </ng-container>

          <ng-container matColumnDef="assetType">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('assetType')">
              Container Type
              <span class="sort-indicator" [ngClass]="getSortDirection('assetType')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ r.assetType }}</td>
          </ng-container>

          <ng-container matColumnDef="locationName">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('locationName')">
              Location
              <span class="sort-indicator" [ngClass]="getSortDirection('locationName')"></span>
            </th>
            <td mat-cell *matCellDef="let r" class="location-cell">{{ r.locationName }}</td>
          </ng-container>

          <ng-container matColumnDef="colour">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('colour')">
              Colour
              <span class="sort-indicator" [ngClass]="getSortDirection('colour')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ r.colour }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('status')">
              Status
              <span class="sort-indicator" [ngClass]="getSortDirection('status')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ r.status }}</td>
          </ng-container>

          <ng-container matColumnDef="condition">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('condition')">
              Condition
              <span class="sort-indicator" [ngClass]="getSortDirection('condition')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ r.condition }}</td>
          </ng-container>

          <ng-container matColumnDef="info">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('info')">
              Info
              <span class="sort-indicator" [ngClass]="getSortDirection('info')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ r.info }}</td>
          </ng-container>

          <ng-container matColumnDef="rowAction">
            <th mat-header-cell *matHeaderCellDef class="row-action-header"></th>
            <td mat-cell *matCellDef="let r" class="row-action-cell">
              <button
                *ngIf="selectedRow === r"
                (click)="goToMoreInfo(r); $event.stopPropagation()"
                class="btn btn-sm more-info-btn more-info-btn--active">
                More Info
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns;"
            class="data-row"
            [class.row-selected]="selectedRow === row"
            (click)="onRowClick(row)"
            (dblclick)="onRowDoubleClick(row)">
          </tr>
        </table>
      </div>

      <div *ngIf="!filteredRows?.length" class="empty">
        No results.
      </div>
    </mat-card>
  </div>
</div>
